// assets
import { Story, DollarSquare, Candle, CpuSetting, Bank, Graph } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  candles: Candle,
  instruments: CpuSetting,
  historicData: Candle,
  brokers: Bank,
  widgets: Story,
  prices: DollarSquare,
  strategies: Graph
};

const app: NavItemType = {
  id: 'App',
  title: 'App',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'brokers',
      title: 'Brokers',
      type: 'item',
      url: '/brokers',
      breadcrumbs: true,
      icon: icons.brokers
    },
    {
      id: 'Instruments',
      title: 'Instruments',
      type: 'item',
      url: '/instruments',
      icon: icons.instruments
    },
    {
      id: 'strategies',
      title: 'Strategies',
      type: 'item',
      url: '/strategies',
      breadcrumbs: true,
      icon: icons.strategies
    }
  ]
};

export default app;
